// extracted by mini-css-extract-plugin
module.exports = {"social":"social_social__3mm4U"};